export default function Plan() {
  return (
    <section id="plan" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              事業計画
            </h2>
            <div className="flex items-center justify-center gap-2">
              <div className="w-12 h-0.5 bg-amber-500"></div>
              <div className="w-2 h-2 bg-amber-500 rotate-45"></div>
              <div className="w-12 h-0.5 bg-amber-500"></div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-white shadow-xl border-l-4 border-amber-500 p-10 hover:shadow-2xl transition-shadow duration-300">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                <div className="w-10 h-10 bg-amber-500 flex items-center justify-center">
                  <i className="ri-money-dollar-circle-line text-xl text-white"></i>
                </div>
                収益モデル
              </h3>
              <ul className="space-y-4 text-slate-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                <li className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-amber-500 mt-2 flex-shrink-0"></div>
                  <span>サービス利用料</span>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-amber-500 mt-2 flex-shrink-0"></div>
                  <span>業務サポート料（代行手数料）</span>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-amber-500 mt-2 flex-shrink-0"></div>
                  <span>デジタルコンテンツ販売</span>
                </li>
              </ul>
            </div>

            <div className="bg-white shadow-xl border-l-4 border-amber-500 p-10 hover:shadow-2xl transition-shadow duration-300">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                <div className="w-10 h-10 bg-amber-500 flex items-center justify-center">
                  <i className="ri-roadmap-line text-xl text-white"></i>
                </div>
                今後の計画
              </h3>
              <div className="space-y-6">
                <div className="pl-6 border-l-2 border-amber-500">
                  <h4 className="font-bold text-slate-900 mb-2 text-lg" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    初年度
                  </h4>
                  <p className="text-slate-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    顧客基盤拡大、月間入金規模2,000万円を想定
                  </p>
                </div>
                <div className="pl-6 border-l-2 border-amber-500">
                  <h4 className="font-bold text-slate-900 mb-2 text-lg" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    次年度以降
                  </h4>
                  <p className="text-slate-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    サービス拡充、安定収益基盤の確立
                  </p>
                </div>
                <div className="pl-6 border-l-2 border-amber-500">
                  <h4 className="font-bold text-slate-900 mb-2 text-lg" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    将来展望
                  </h4>
                  <p className="text-slate-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    海外顧客への展開も視野
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white shadow-xl border-l-4 border-amber-500 p-10 hover:shadow-2xl transition-shadow duration-300">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" style={{ fontFamily: '"Noto Serif JP", serif' }}>
                <div className="w-10 h-10 bg-amber-500 flex items-center justify-center">
                  <i className="ri-funds-line text-xl text-white"></i>
                </div>
                資金の使途
              </h3>
              <ul className="space-y-4 text-slate-700" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                <li className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-amber-500 mt-2 flex-shrink-0"></div>
                  <span>サーバー・クラウド環境整備</span>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-amber-500 mt-2 flex-shrink-0"></div>
                  <span>広告宣伝費（オンラインマーケティング）</span>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-2 h-2 bg-amber-500 mt-2 flex-shrink-0"></div>
                  <span>業務運営費（人件費・事務所維持費）</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
